import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e667d57"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-page" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "main-content" }
const _hoisted_4 = { class: "main-inner-content" }
const _hoisted_5 = { class: "login-button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_LoginButton = _resolveComponent("LoginButton")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["main", { 'main-default-bg': _ctx.isImageLoaded }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: require('@hems/component/resources/images/main/qcells-energy-solutions-bg.jpg'),
        class: "bg-img",
        alt: "Background",
        onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onLoadImage && _ctx.onLoadImage(...args)))
      }, null, 40, _hoisted_2),
      _createVNode(_component_Header, {
        "is-login": _ctx.isLogin,
        onChangeLanguage: _ctx.changeLanguage,
        onLogout: _ctx.onLogout
      }, null, 8, ["is-login", "onChangeLanguage", "onLogout"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t('message.landing_page_title')), 1),
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('common.hems')) + ", Q.OMMAND", 1),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_LoginButton, {
              "is-login": _ctx.isLogin,
              "login-tenant": _ctx.TENANT.PARTNERS,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClickLoginButton(_ctx.TENANT.PARTNERS)))
            }, null, 8, ["is-login", "login-tenant"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Footer, {
      onOnOpenMobileAppLinkModal: _ctx.openMobileAppLinkModal,
      onOnOpenPrivacyPolicyModal: _ctx.openPrivacyPolicyModal
    }, null, 8, ["onOnOpenMobileAppLinkModal", "onOnOpenPrivacyPolicyModal"])
  ], 2))
}